
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import LineChart from '../LineChart/index.vue'
import type { MyClassroomType } from '@xt/client/entities/my-v2/types'
import TooltipPop from '../../../views/ToolPopover/index.vue'

@Observer
@Component({
  components: {
    LineChart,
    TooltipPop
  }
})
export default class StudyRecord extends Vue {
  @Prop() dataSource: MyClassroomType['StudyRecord']

  tooltipText: {
    title: string
    content: string[]
  } = {
    title: '数据更新时间说明',
    content: ['当日产生的学习数据将在两日后零点更新', '学习数据相关的更新时间均以此时间为准']
  }

  // LineChart 组件配置
  get chartContent() {
    return {
      dataSource: this.dataSource.lastWeekLearnData.map(item => item.time),
      config: {
        lineWidth: 1,
        lineColor: '#F1E0E0',
        containerW: 275,
        containerH: 48,
        innerRadius: 1.5,
        outerRadius: 2.5,
        innerColor: '#F1E0E0',
        outerColor: '#D9A8A8',
        // --- 新增参数 ---
        unit: '分',
        labelColor: '#D9A8A8',
        labelFontSize: 10,
        fillColor: ['rgba(247, 230, 228)', 'rgba(255, 255, 255)'],
        tension: 0.8
      }
    }
  }
  // 数据更新时间
  get updateTime() {
    const now = this.$ajax.serviceDate().utcOffset(+8)
    const weekArr = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

    return {
      date: now,
      updateTime: now.subtract(2, 'day').format('YYYY.MM.DD'),
      updateWeekDay: weekArr[now.day()]
    }
  }

  // 获取自然周时间区间
  get naturalWeek() {
    return {
      start: this.updateTime.date.startOf('week').valueOf(),
      end: this.updateTime.date.endOf('week').valueOf()
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
